<template>
  <v-dialog v-model="showDialog" scrollable persistent max-width="650" >
    <v-card>
      <v-card-title>
        <v-icon color="secondary">smartphone</v-icon>
        <span>&ensp;</span>
        <span class="secondary--text">
          <strong>{{ device.name }}</strong>
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            ID
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="device.loco_id" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.owner') }}
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="device.owner_name" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.is_mounted') }}
          </v-flex>
          <v-flex xs9>
            <v-radio-group v-model="device.mounted" row class="mt-0" readonly>
              <v-radio :label="$t('items.mounted')" :value="true" />
              <v-radio :label="$t('items.movable')" :value="false" />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.name') }}
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="device.name" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            UUID
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="device.device_id" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.manufacturer_id') }}
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="device.manufacturer_id" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            MANUFACTURER
          </v-flex>
          <v-flex xs9>
            <v-btn
              color="primary"
              class="white--text"
            >
              <span>{{ device.manufacturer }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="success" @click="onClose">
          {{ $t('common.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    device: { type: Object, required: true },
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      showDialog: this.value
    };
  },
  watch: {
    value(val) {
      this.showDialog = val;
    },
    showDialog(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    onClose() {
      this.showDialog = false;
    }
  }
};
</script>
